import { GroupPosition, TempOrderLineProductContract, TempOrderLineProductContractUiHelper } from "./interfaces/temp-order-line-product-contract.js";
import { OrderLineType } from "../../../components-shared/enums/order-line-type.js";

export class CartControllerUtils {

    private _addOfferOrderLineDummyHeading(orderLines: TempOrderLineProductContract[]): TempOrderLineProductContractUiHelper[]{
        let updatedProducts: TempOrderLineProductContract[] = [];

        orderLines.forEach((product, index) => {
            if (product.offerID) {

                if((index >= 1 && !orderLines[index - 1].offerID) || index === 0){
                    const offerHeadingOrderLine = {
                        tempOrderLineID: product.tempOrderLineID, //copy
                        productID: null,
                        productNo: null,
                        productName: 'Offer Nr: ' + product.offerID.toString(), //copy
                        quantity: null,
                        lockQuantity: null,
                        price: null,
                        linePrice: null,
                        lineDiscount: null,
                        lineDiscountPercent: null,
                        imageID: null,
                        parentID: product.parentID, //copy
                        preventBuyWhenOutOfStock: null,                        
                        quantityInStock: null,
                        itemID: null,
                        productImageID: null,
                        imageWidth: null,
                        exchangeRate: 0,
                        published: null,
                        formattedPrice: '',
                        formattedLinePrice: '',
                        formattedDiscount: '',
                        factor: null,
                        publishedPageID: null,
                        isMainProduct: null,
                        imageFullWidth: null,
                        imageFullHeight: null,
                        imageDisplayWidth: null,
                        imageDisplayHeight: null,
                        imageUrl: '',
                        cantBeRemoved: false, //override
                        stockText: '',
                        stockCssClass: '',
                        hideStockInfo: null,
                        minQuantity: null,
                        allowedQuantities: [],
                        unit: '',
                        isFractional: null,
                        factorPurchaseType: null,
                        productUrl: null,
                        lineType: product.lineType, //copy
                        offerID: product.offerID, //copy
                        customFields: []
                    } as TempOrderLineProductContract;

                    updatedProducts.push(offerHeadingOrderLine);
                }
                product.cantBeRemoved = true;
            }
            updatedProducts.push(product);
        });

        return updatedProducts as TempOrderLineProductContractUiHelper[];
    }

    public extendDataForUi(orderLines: TempOrderLineProductContract[]): TempOrderLineProductContractUiHelper[]{
        const hasOfferProducts = orderLines.some(product => product.offerID);
        let updatedProducts = [ ... orderLines ] as TempOrderLineProductContractUiHelper[];

        updatedProducts = orderLines.filter(product => {
            return product.lineType === OrderLineType.ExtraField ? product.productName.trim() !== '' : true;
        });

        if (hasOfferProducts) {
            updatedProducts = this._addOfferOrderLineDummyHeading(updatedProducts);
        }

        return updatedProducts;
    }

    public setGroupingParams(orderLines: TempOrderLineProductContractUiHelper[], ignoreGroupingProducts: boolean = false): TempOrderLineProductContractUiHelper[]{
        let updatedProducts = [ ... orderLines ] as TempOrderLineProductContractUiHelper[];
        const hasOrderLineForGrouping = orderLines.some(product => product.parentID > 0 || product.offerID);

        if (!hasOrderLineForGrouping) return orderLines;

        const orderLinesIndexMap: Map<number, number[]> = new Map();
        let orderLineGroupingIndex: number = 0;
        let previousOfferID: number = null;
        let previousGroupingProductID: number = null;

        orderLines.forEach((product, index) => {
            if (!isGroupingConditionMet(product)) {
                return;
            }

            const offerID = product.offerID;

            if (isNewOrderLinesGroup(product, offerID)) {
                previousOfferID = offerID;
                previousGroupingProductID = product.tempOrderLineID;
                orderLineGroupingIndex++;
            }

            if (!orderLinesIndexMap.has(orderLineGroupingIndex)) {
                orderLinesIndexMap.set(orderLineGroupingIndex, []);
            }

            orderLinesIndexMap.get(orderLineGroupingIndex).push(index);
        });

        orderLinesIndexMap.forEach((indexes, orderLineGroupingIndex) => {
            const productsInGroup = orderLinesIndexMap.get(orderLineGroupingIndex);
            indexes.forEach(index => {
                const indexInGroup = productsInGroup.findIndex((p) => p === index);
                updatedProducts[index].grouping = orderLines[index].grouping || { id: null, position: null, isChild: null };
                updatedProducts[index].grouping.id = orderLineGroupingIndex;
                updatedProducts[index].grouping.position = getGroupingPosition(indexInGroup, productsInGroup.length);
                updatedProducts[index].grouping.isChild = indexInGroup !== 0 ? true : false;
            });
        });
        

        function isGroupingConditionMet(product: TempOrderLineProductContract){
            return (!ignoreGroupingProducts && product.lineType === OrderLineType.GroupingProduct) || (isMainProductByParentID(product) || product.parentID > 0) || product.offerID !== undefined;
        }

        function isNewOrderLinesGroup(product: TempOrderLineProductContract, offerID: number){
            const isNewOfferProduct: boolean = product.offerID !== undefined && previousOfferID !== offerID;
            const isNewGroupingProduct: boolean = product.lineType === OrderLineType.GroupingProduct && previousGroupingProductID !== product.tempOrderLineID && product.offerID === undefined;
            return isMainProductByParentID(product) || isNewOfferProduct || isNewGroupingProduct;
        }

        function isMainProductByParentID(product: TempOrderLineProductContract){
            return product.parentID === 0 && product.offerID === undefined && orderLines.some(p => p.parentID === product.tempOrderLineID);
        }

        function getGroupingPosition(indexInGroup: number, totalProductsInGroup: number): GroupPosition {
            if (indexInGroup === 0) {
                return GroupPosition.First;
            } else if (indexInGroup === totalProductsInGroup - 1) {
                return GroupPosition.Last;
            } else {
                return GroupPosition.Middle;
            }
        }

        return updatedProducts;
    }
}